import React from 'react';
import ReactDOM from 'react-dom';
// import { setMockStatus } from '@hb/mockInitSDK';
import 'mobx-react/batchingForReactDom';
import { hot } from 'react-hot-loader';
import PreStart from '@/utils/pre-start';
import './index.module.scss';
import Router from './router';
import { initNativeMap } from './utils/maps/gaodeMap';
// import env from 'utils/env';
// import Native from 'utils/nativeProxy';
// import './register-service-worker';

let App = () => {
  return (
    // <React.StrictMode>
    <Router />
    // </React.StrictMode>
  );
};

if (process.env.NODE_ENV === 'development') {
  App = hot(module)(App);
}

const initRender = async () => {
  try {
    await PreStart();
    // if (env.codeEnv !== 'pro') {
    //   try {
    //     const { token } = await Native.getTokenAndKey(true);
    //     await setMockStatus({
    //       token,
    //       env: env.codeEnv,
    //     });
    //   } catch (e) {
    //     //
    //   }
    // }
  } catch (e) {
    // console.info(e);
  }

  console.info('render');
  ReactDOM.render(<App />, document.getElementById('root'));
};

initRender();

/* 初始化高德配置 */
initNativeMap();
